import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import {
  DepositSystems,
  DepositSystemsClass,
  TelecomProvider,
} from "../../../source/modules/cashier/depositSystems";
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Subscription, filter } from 'rxjs';
import { SlotsService } from '../../../source/services/slotsservice/slots.service';
import { PlayerGetProfile } from '../../../source/appstates/playerstates/playerActions';
import { LoginState } from '../../../source/appstates/loginstates/loginState';
import { ProfileState } from '../../../source/appstates/playerstates/playerState';
import * as appState from '../../../source/appstates/appState';
import * as cashierActions from '../../../source/appstates/cashierstates/cashierActions';
import { Profile } from '../../../source/modules/player/profile';
import { Meta, Title } from '@angular/platform-browser';
import { CommondataService } from '../../../source/services/games/commondata.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-deposit',
  standalone: true,
  imports: [CommonModule, TranslateModule, ReactiveFormsModule, FormsModule],
  templateUrl: './deposit.component.html',
  styleUrls: ['./deposit.component.css']
})
export class DepositComponent implements OnInit, OnDestroy {
  playerLoggedIn: boolean = false;
  formPaykassmaUPI!: FormGroup;
  payMethod: string = '';
  urlSafe: SafeResourceUrl | null = null;
  interFalseRes: string | null = null;
  smallLoader: boolean = false;
  iframeLoaded: boolean = false;
  private loginSub: Subscription;
  private storeSub: Subscription | null = null;
  private profile!: Profile;

  isSpinner: boolean = true
  DepositTypeName: any = 'Nagad';
  @ViewChild('paymentIframe') paymentIframe!: ElementRef;
  activePayMethod: any = 'coinPayments';
  DMamount: any = 10;
  gadgetType: any;
  playerName: any;
  playerEmail: any;
  public urlSafe$ = this.popupService.urlSafe$;
  isPopupVisible: boolean = false;
  constructor(
    private sanitizer: DomSanitizer,
    private router: Router,
    private store: Store<appState.AppState>,
    private playerSer: SlotsService,
    private meta: Meta, private title: Title,
    private route: ActivatedRoute,
    public popupService: CommondataService,
    private cdr: ChangeDetectorRef, private translate: TranslateService
  ) {
    this.store.dispatch(new cashierActions.CashierGetBalanceStart());
    this.store.dispatch(new PlayerGetProfile());

    this.loginSub = this.store
      .select("loginState")
      .subscribe((loginState: LoginState) => {
        this.playerLoggedIn = loginState.playerLoggedIn?.loggedIn || false;
        if (!this.playerLoggedIn) {
          this.router.navigate(["/home"]);
        }
      });
  }

  ngOnInit(): void {
    this.router.events
      .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
      .subscribe(event => {
        const url = event.urlAfterRedirects;

        if (url.startsWith('/home') && url.includes('status=Created')) {

          setTimeout(() => {
            this.popupService.close();      // popup close
            this.cdr.detectChanges(); // 🔥 FIX NG0100
          });

          this.router.navigate(['/home'], { replaceUrl: true });
        }
      });
    this.popupService.urlSafe$.subscribe(url => {
      if (url) {
        // Open popup
        this.isPopupVisible = true;
        this.urlSafe = url;
      } else {
        // Close popup
        this.isPopupVisible = false;
        this.urlSafe = null;
      }
    });

    this.initForm();
    const title = 'Make a Deposit - Secure Transactions at Gambaji';
    const discript = "Deposit funds quickly and securely at Gambaji. Explore a variety of payment options for seamless transactions and start enjoying your favorite casino games.";
    this.translate.get('DEPOSIT_TITLE').subscribe(res => {
      this.title.setTitle(res);
      this.meta.updateTag({ property: 'og:title', content: res });
    });

    this.translate.get('DEPOSIT_DESCRIPTION').subscribe(res => {
      this.meta.updateTag({ name: 'description', content: res });
      this.meta.updateTag({ property: 'og:description', content: res });
    });



    const url = 'https://gambaji.com' + this.router.url;
    this.meta.updateTag({ property: 'og:url', content: url });
    this.isSpinner = false;
    this.storeSub = this.store.select("playerState").subscribe((playerState: ProfileState) => {
      if (playerState.profile) {
        if (playerState.profile.success == true) {
          this.profile = playerState.profile;
          this.playerEmail = this.profile.email;
          this.playerName = this.profile.login;
        }
      }
    });


  }

  ngOnDestroy(): void {
    this.loginSub.unsubscribe();
    if (this.storeSub) {
      this.storeSub.unsubscribe();
    }
    var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    // var isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
    this.gadgetType = isMobile ? "Phone" : "Desktop";
    console.log(this.gadgetType)
  }

  payMethodChange(method: any) {
    this.activePayMethod = method;
    this.setAmountValidators();
  }

  setAmountValidators() {
    const amountControl = this.formPaykassmaUPI.get("amount");
    if (!amountControl) return;

    amountControl.clearValidators();

    if (this.activePayMethod == "coinPayments") {
      // this.DMamount = this.gadgetType == 'Desktop' ? 10001 : 300
      amountControl.setValidators([
        Validators.required, Validators.min(5), Validators.max(5000)
      ]);
    }
    else if (this.activePayMethod == "nova pay") {
      amountControl.setValidators([
        Validators.required, Validators.min(5), Validators.max(5000)
      ])
    }

    amountControl.updateValueAndValidity();
  }

  private initForm(): void {
    this.formPaykassmaUPI = new FormGroup({
      amount: new FormControl('', [Validators.required, Validators.min(100), Validators.max(50000)])
    });
  }

  depositPaykassma(type: string): void {
    if (this.formPaykassmaUPI.invalid) return;

    this.smallLoader = true;
    this.payMethod = type;



    const paykassmaBody: any = {
      "paymentMethod": "345",
      "paymentType": "deposit",
      "type": "deposit",
      "currency": sessionStorage.getItem('wallet'),
      "amount": this.formPaykassmaUPI.value.amount,
      "userName": this.playerName,
      "emailId": this.playerEmail,
      "payMethod": this.DepositTypeName,
      // "payMethod": "upay",
    };

    this.playerSer.playerDeposit(paykassmaBody).subscribe({
      next: (data) => this.paykassmaDepositHandler(data),
      error: (err) => this.handleDepositError(err)
    });
  }
  isIOS(): boolean {
    const ua = window.navigator.userAgent.toLowerCase();
    return /iphone|ipad|ipod/.test(ua);
  }
  private paykassmaDepositHandler(data: any): void {
    this.smallLoader = false;

    if (data.success === false) {
      this.interFalseRes = data.description;
      setTimeout(() => this.interFalseRes = null, 3000);
      return;
    }

    if (this.payMethod === "CRIPTO" && data?.result?.form?.url) {
      if (this.playerLoggedIn) {
        this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(data.result.form.url);
        //  window.location.href  = data.result.form.url
      }
    } else {
      const redirectUrl = data.result['redirectUrl'];
      // this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(data.result['redirectUrl']);
      if (redirectUrl) {
        if (this.isIOS()) {
          // ✅ iOS → open popup (iframe) 
          const safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(redirectUrl);
          this.popupService.open(safeUrl);
        } else {
          // ✅ Other devices → open in new tab
          const safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(redirectUrl);
          this.popupService.open(safeUrl);
          // window.location.href = redirectUrl;

        }
      }
    }

    this.formPaykassmaUPI.reset();
    this.store.dispatch(new cashierActions.CashierGetBalanceStart());
  }

  private handleDepositError(error: any): void {
    this.smallLoader = false;
    this.interFalseRes = 'Deposit failed. Please try again.';
    setTimeout(() => this.interFalseRes = null, 3000);
  }

  onIframeLoaded() {
    this.iframeLoaded = true;
  }

  closeIframe(): void {
    this.urlSafe = null;
    this.popupService.close();
    this.iframeLoaded = false;
    this.isPopupVisible = false;
  }


  preventPlusMinus(event: KeyboardEvent): void {
    if (event.key === '+' || event.key === '-') {
      event.preventDefault();
    }
  }
  goWithdraw() {
    this.router.navigate([], {
      queryParams: { modal: 'cashout' }, // OR outlet if using that
      queryParamsHandling: 'merge'
    });
  }
  DepositType(type: any) {
    console.log(type)
    this.DepositTypeName = type
  }
}